<template>
  <div style="width: 100%;" v-loading.body="loading">
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <el-row type="flex" align="middle" justify="start" style="font-size: 1.5em;">
          PAYROLL TRANSACTION REPORTING
        </el-row>
      </el-col>
      <el-col class="small">
          <a @click="showJson = ! showJson">.&nbsp;</a>
      </el-col>
      <el-col>
        <el-row type="flex" align="middle" justify="end">
          <el-tag v-if="disableReportRun" type="primary">
            <el-icon class="is-loading" style="margin: 0 6px;"><Loading/></el-icon>Running
          </el-tag>
          <el-button type="warning" plain @click="resetComponent" :disabled="disableReportRun">
            Reset
          </el-button>
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <el-row type="flex" align="middle" justify="start" style="font-size: 1.2em;">
          Invoice Based Reports
        </el-row>
      </el-col>
    </el-row>

    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="2" class="right">
        Payroll Number
      </el-col>
      <el-col :span="3">
        <el-input v-model="selectedCodes.doc_number" placeholder=""/>
      </el-col>
      <el-col :span="2" class="right">
        Payroll ID
      </el-col>
      <el-col :span="3">
        <el-input v-model="selectedCodes.transaction_id" placeholder=""/>
      </el-col>
      <el-col :span="3" class="right">
        Employee (for Paystubs)
      </el-col>
      <el-col :span="4">
        <autocomplete
          name="employee-autocomplete"
          ref="employee-autocomplete"
          :resourceClass="resources.EmployeeResource"
          @select="selectEmployee($event)">
          <template v-slot:item="option">
            <span v-if="option.item.resource && option.item.resource.attributes.is_loanout">
              {{ option.item.resource.attributes.loanout_name }}
            </span>
            <p v-if="option.item.resource">
              {{ option.item.resource.attributes.last_name }},
              {{ option.item.resource.attributes.first_name }}<br />
              Code: {{ option.code }} - <span v-if="option.item.resource.attributes.is_loanout == true">FEIN: {{ option.item.resource.attributes.fein_last_4 }}</span>
              <span> / TIN: {{ option.item.resource.attributes.masked_tin }}</span>
            </p>
            <p v-else>{{ option.code }}</p>
          </template>
        </autocomplete>
      </el-col>
      <el-col :span="2" class="right">
        Start_Date
      </el-col>
      <el-col :span="2">
          <DateField v-model="invoice_based_pay_period_date_start" />
        </el-col>
      <el-col :span="2" class="right">
        End_Date
      </el-col>
      <el-col :span="2">
          <DateField v-model="invoice_based_pay_period_date_end" />
        </el-col>
    </el-row>

    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Report Type
      </el-col>
      <el-col :span="21">
        <el-radio-group v-model="reportOptions.type" @change="generateReport">
          <el-radio-button value="payrollInvoice">Invoice</el-radio-button>
          <el-radio-button value="detailPayEdit">Detail Pay Edit</el-radio-button>
          <el-radio-button value="customTimeEntry">Custom Time Entry Summary</el-radio-button>
          <el-radio-button value="payrollCheckRegister">Wage Register</el-radio-button>
          <el-radio-button value="fringeRecap">Fringe Recap</el-radio-button>
          <el-radio-button value="paystub">Paystub</el-radio-button>
          <el-radio-button value="payrollWageList">Wage Spreadsheet</el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>
    <hr />
    <div class="m-top-100">
      <el-row type="flex" align="middle" justify="end" class="headerRow m-top-100">
        <el-col>
          <el-row type="flex" align="middle" justify="start" style="font-size: 1.2em;">
            Client Based Reports
          </el-row>
        </el-col>
      </el-row>

      <el-row type="flex" align="middle" justify="start" class="headerRow">
        <el-col :span="2"></el-col>
        <el-col :span="3">Client</el-col>
        <el-col :span="2"></el-col>
        <el-col :span="3">Project</el-col>
        <el-col :span="2"></el-col>
        <el-col :span="3">Pay Period Date Start</el-col>
        <el-col :span="2"></el-col>
        <el-col :span="3">Pay Period Date End</el-col>
        <el-col :span="1"></el-col>
        <el-col :span="3">Pay Code</el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="2"></el-col>
        <el-col :span="3">
          <autocomplete
            name="client-autocomplete"
            ref="client-autocomplete"
            :resourceClass="resources.ClientResource"
            @select="selectClient($event)">
            <template v-slot:item="option">
              <p v-if="option.item.resource">{{ option.item.resource.attributes.name_reports }}</p>
              <p v-else>{{ option.code }}</p>
            </template>
          </autocomplete>
        </el-col>
        <el-col :span="2"></el-col>
        <el-col :span="3">
          <autocomplete
            name="project-autocomplete"
            ref="project-autocomplete"
            :resourceClass="resources.ProjectResource"
            @select="selectProject($event)">
            <template v-slot:item="option">
              <p v-if="option.item.resource">{{ option.item.resource.attributes.name }}</p>
              <p v-else>{{ option.code }}</p>
            </template>
          </autocomplete>
        </el-col>
        <el-col :span="2"></el-col>
        <el-col :span="3">
          <DateField v-model="selectedCodes.pay_period_start_date" />
        </el-col>
        <el-col :span="2"></el-col>
        <el-col :span="3">
          <DateField v-model="selectedCodes.pay_period_end_date" />
        </el-col>
        <el-col :span="1"></el-col>
        <el-col :span="3">
          <autocomplete
            name="paycode-autocomplete"
            ref="paycode-autocomplete"
            :resourceClass="resources.PayCodeResource"
            @select="selectPaycode($event)">
            <template v-slot:item="option">
              <p v-if="option.item.resource">{{ option.item.resource.attributes.name }}</p>
              <p v-else>{{ option.code }}</p>
            </template>
          </autocomplete>
        </el-col>
      </el-row>
    </div>

    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Report Type
      </el-col>
      <el-col :span="21">
        <el-radio-group v-model="reportOptions.type" @change="generateReport">
          <el-radio-button value="aggregateFringeRecap">Aggregate Fringe Recap</el-radio-button>
          <el-radio-button value="aggregateFringeRecapByPaycode">Aggregate Paycode Recap</el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>
    <el-row v-if="showJson">
      <el-col>
        <textarea id="output" style="width: 100%; height: 500px;" v-model="prettyJson"></textarea>
      </el-col>
    </el-row>
    <el-row v-show="wageRowData">
      <el-col>
        <payroll-wage-list
          name="payroll_wage_list"
          ref="payroll_wage_list"
          :key="iteration"
          :width="width"
          :height="height"
          :row-data="wageRowData"
          @update-totals="onUpdateTotals"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { PayrollInvoiceData } from '@/utils/helpers/PayrollData'
  import { EmployeeResource, ClientResource, ProjectResource, AddressResource, StateResource, CityResource, PayCodeResource } from '@sigmacloud/sigma-client/dist/resources'
  import ReportCheckStubHistoryResource from '@/resources/ReportCheckStubHistoryResource'
  import { reportMixins } from '@/Mixins/Reports'
  import Autocomplete from '@/components/SigmaClientNew/Autocomplete.vue'
  import DateField from '@/components/InputComponents/DateField.vue'
  import PayrollWageList from '@/components/SigmaClientNew/PayrollWageList.vue'

  export default {
    name: 'PayrollReports',
    components: {
      Autocomplete,
      DateField,
      PayrollWageList
    },
    mixins: [ reportMixins ],
    data () {
      return {
        payrollData: undefined,
        invoice_based_pay_period_date_start: undefined,
        invoice_based_pay_period_date_end: undefined,
        reportOptions: {
          transactionStatuses: [ 'draft', 'open', 'audited', 'posted' ],
          accountQuickPick: 'all',
          type: null,
          dates: 'datesAll',
          sort: 'account',
          status: 'all',
          format: 'pdf',
          currencyFactor: undefined,
          report_currency_id: 1,
          paycodeId: undefined
        },
        allCodes: {},    // Show codes, e.g. accounts, series, locations, sets, etc.
        selectedCodes: {
          period_start: undefined,
          period_end: undefined,
          time_posted_start: undefined,
          time_posted_end: undefined,
          effective_date_start: undefined,
          effective_date_end: undefined,
          pay_period_start_date: undefined,
          pay_period_end_date: undefined,
          client_id: undefined,
          project_id: undefined,
          account_id: [],
          company_id: undefined,
          transaction_id: undefined,
          employee_id: undefined,
          doc_number: undefined,
          currency_id: []
        },
        jasperSettings: {
          reportServer: 'https://jasper2.revolutiones.com:8443/jasperserver/rest_v2/reports/Revolution/Payroll/',
          reportName: 'pr_detail_edit_report'
        },
        vendors: undefined,
        transactionTypes: {     // Types of transactions and whether we need them or not
          // 'prs': { name: 'PR', include: false }
          'prs': { name: 'PRINV', include: true }
        },
        unserializedData: {      // Raw data from API
          aps: {
            headers: {},
            lines: {}
          },
          jes: {
            headers: {},
            lines: {}
          },
          pcs: {
            headers: {},
            lines: {}
          },
          cks: {
            headers: {},
            lines: {}
          },
          pos: {
            headers: {},
            lines: {}
          }
        },
        reportOutputFormats: [
          { value: 'pdf', label: 'PDF' },
          { value: 'csv', label: 'CSV' }
        ],
        sortedAccounts: [],     // Sorted data by accounts, transaction ID.  Needed for 90% of reports
        disableReportRun: false, // Disable run report button if false
        reportJson: undefined,
        prettyJson: undefined,
        showJson: false,
        reportNotif: undefined,
        collapseExpenses: false,
        loading: false,
        wageRowData: undefined
      }
    },

    computed: {
      resources () {
        return {
          EmployeeResource: EmployeeResource,
          ClientResource: ClientResource,
          ProjectResource: ProjectResource,
          AddressResource: AddressResource,
          StateResource: StateResource,
          CityResource: CityResource,
          PayCodeResource: PayCodeResource,
          ReportCheckStubHistoryResource: ReportCheckStubHistoryResource
        }
      },
      username () { return this.$store.getters.getUser.username },
      token () { return this.$store.getters.getActiveInstance.token },
      includedTypes () {
        return Object.values(this.transactionTypes).filter(types => types.include === true).map(type => type.name)
      },
      dateStart () {
        switch (this.reportOptions.dates) {
          case 'datesPeriod':
            return (this.allCodes.periods.find(({id}) => id === this.selectedCodes.period_start) || {}).start || '0000/00/00'

          case 'datesEffective':
            return this.selectedCodes.effective_date_start || '0000/00/00'

          case 'datesPosted':
            return this.selectedCodes.time_posted_start || '0000/00/00'

          default:
            return 'ALL'
        }
      },
      dateEnd () {
        switch (this.reportOptions.dates) {
          case 'datesPeriod':
            return (this.allCodes.periods.find(({id}) => id === this.selectedCodes.period_end) || {}).end || '9999/99/99'

          case 'datesEffective':
            return this.selectedCodes.effective_date_end || '9999/99/99'

          case 'datesPosted':
            return this.selectedCodes.time_posted_end || '9999/99/99'

          default:
            return 'ALL'
        }
      },
      width () {
        return '100%'
      },
      height () {
        return window.innerHeight * 0.5 + 'px'
      }
    },
    methods: {
      resetComponent () {
        this.reportJson = this.vendors = this.sortedAccounts = undefined
        for (const i in this.selectedCodes) {
          if (typeof this.selectedCodes[i] === 'object' && Array.isArray(this.selectedCodes[i])) this.selectedCodes[i] = []
          else if (typeof this.selectedCodes[i] === 'object') this.selectedCodes[i] = {}
          else this.selectedCodes[i] = undefined
        }
        this.disableReportRun = false
        this.loading = false
        this.clearStore()
        this.$refs['client-autocomplete'].reset()
        this.$refs['project-autocomplete'].reset()
        this.$refs['employee-autocomplete'].reset()
        this.$refs['paycode-autocomplete'].reset()
      },
      clearStore () {
        // TODO
      },
      updateReportType (type) {
        this.jasperSettings.reportName = 'general_ledger_' + type
      },
      updateReportDates (type) {
        this.selectedCodes.period_start = this.selectedCodes.period_end = this.selectedCodes.time_posted_start = this.selectedCodes.time_posted_end = this.selectedCodes.effective_date_start = this.selectedCodes.effective_date_end = undefined
      },
      selectEmployee (resource) {
        // console.log(resource.attributes.id)
        this.selectedCodes.employee_id = resource ? resource.attributes.id : undefined
      },
      selectClient (resource) {
        this.selectedCodes.client_id = resource ? resource.attributes.id : undefined
      },
      selectProject (resource) {
        this.selectedCodes.project_id = resource ? resource.attributes.id : undefined
      },
      selectPaycode (resource) {
        // console.log(resource.attributes.id)
        this.reportOptions.paycodeId = resource ? resource.attributes.id : undefined
      },
      includePrs ({target}) {
        this.transactionTypes.prs.include = target.checked
      },
      selectReportFormat ({target}) {
        if (target.checked) {
          this.reportOptions.format = 'csv'
        } else {
          this.reportOptions.format = 'pdf'
        }
      },
      buildCsvData (sortedAccounts) {
        if (!sortedAccounts || !Array.isArray(sortedAccounts)) return false

        let detailedColumns = { 'Company': 'company_name', 'Production': 'production_name', 'Transaction Type': 'trans_type', 'Transaction ID': 'trans_number', 'Transaction Description': 'transaction_description', 'Transaction Line Description': 'line_desc', 'Account': 'account', 'Account Description': 'account_name', 'Vendor Code': 'transaction_vendor', 'Vendor Name': 'vendor_name', 'Series': 'series', 'Location': 'location', 'Set': 'set', 'FF1': 'free_field_1', 'FF2': 'free_field_2', 'Tax Code': 'tax_code', 'Asset': 'asset', 'Document Number': 'doc_number', 'Document Date': 'doc_date', 'Posting Date': 'transaction_time_posted', 'Effective Date': 'transaction_effective_date', 'Period': 'transaction_period_id', 'PO Number': 'po_number', 'Check Number': 'payment_number', 'Check Amount': 'transaction_payment_amount', 'Bank Recon': 'recon', 'Amount': 'amount' }
        let summaryColumns = { 'Account': 'account_number', 'Account Description': 'account_desc', 'Amount': 'account_total' }
        // detailedColumns = { 'account_number': 'account', 'account_desc': 'account_name', 'amount': 'amount', 'account': 'account', 'period': 'transaction_period_name', 'transaction_vendor': 'vendor_name', 'vendor_id': 'transaction_vendor', 'account_header': 'account_header', 'series': 'series', 'location': 'location', 'set': 'set', 'free_field_1': 'free_field_1', 'free_field_2': 'free_field_2', 'free_field_3': 'free_field_3', 'free_field_4': 'free_field_4', 'asset': 'asset', 'tax_code': 'tax_code', 'line_desc': 'line_desc', 'recon': 'recon', 'trans_type': 'trans_type', 'trans_number': 'trans_number', 'line_number': 'line_number', 'doc_date': 'doc_date', 'doc_number': 'doc_number', 'company': 'company_name', 'production': 'production_name', 'batch': 'transaction_batch_name', 'transaction_credits_decimal': 'transaction_credits_decimal', 'transaction_number': 'doc_number', 'transaction_confirmation_number': 'transaction_confirmation_number', 'transaction_original_trx_number': 'transaction_original_trx_number', 'transaction_ledger': 'transaction_ledger_id', 'transaction_description': 'transaction_description', 'transaction_date': 'doc_date', 'transaction_time_posted': 'transaction_time_posted', 'transaction_batch': 'transaction_batch', 'transaction_source_code': 'source_code', 'transaction_effective_date': 'transaction_effective_date', 'transaction_debits_decimal': 'transaction_debits_decimal', 'transaction_status': 'transaction_status', 'transaction_id': 'subledger_id', 'transaction_period': 'transaction_period_id', 'payment_number': 'payment_number', 'transaction_date_due': 'transaction_date_due', 'transaction_vendor_code': 'transaction_vendor', 'transaction_payment_combine_checks': 'transaction_payment_combine_checks', 'transaction_payment_check_split': 'transaction_payment_check_split', 'transaction_state': 'transaction_state', 'transaction_discount_decimal': 'transaction_discount_decimal', 'transaction_payment_check_pickup': 'transaction_payment_check_pickup', 'transaction_payment_type': 'transaction_payment_type', 'transaction_payment_confirmation_number': 'transaction_payment_confirmation_number', 'transaction_amount_decimal': 'transaction_amount_decimal' }
        // let sipraColumnMap = { 'account_number': 'account', 'account_desc': 'account_name', 'amount': 'amount', 'account': 'account', 'period': 'transaction_period_name', 'transaction_vendor': 'vendor_name', 'vendor_id': 'transaction_vendor', 'account_header': 'account_header', 'series': 'series', 'location': 'location', 'set': 'set', 'free_field_1': 'free_field_1', 'free_field_2': 'free_field_2', 'free_field_3': 'free_field_3', 'free_field_4': 'free_field_4', 'asset': 'asset', 'tax_code': 'tax_code', 'line_desc': 'line_desc', 'recon': 'recon', 'trans_type': 'trans_type', 'trans_number': 'trans_number', 'doc_date': 'doc_date', 'doc_number': 'doc_number', 'company': 'company_name', 'production': 'production_name', 'batch': 'transaction_batch_name', 'transaction_credits_decimal': 'transaction_credits_decimal', 'transaction_number': 'doc_number', 'transaction_confirmation_number': 'transaction_confirmation_number', 'transaction_original_trx_number': 'transaction_original_trx_number', 'transaction_ledger': 'transaction_ledger_id', 'transaction_description': 'transaction_description', 'transaction_date': 'doc_date', 'transaction_time_posted': 'transaction_time_posted', 'transaction_batch': 'transaction_batch', 'transaction_source_code': 'source_code', 'transaction_effective_date': 'transaction_effective_date', 'transaction_debits_decimal': 'transaction_debits_decimal', 'transaction_status': 'transaction_status', 'transaction_id': 'subledger_id', 'transaction_period': 'transaction_period_id', 'payment_number': 'payment_number', 'transaction_date_due': 'transaction_date_due', 'transaction_vendor_code': 'transaction_vendor', 'transaction_payment_combine_checks': 'transaction_payment_combine_checks', 'transaction_payment_check_split': 'transaction_payment_check_split', 'transaction_state': 'transaction_state', 'transaction_discount_decimal': 'transaction_discount_decimal', 'transaction_payment_check_pickup': 'transaction_payment_check_pickup', 'transaction_payment_type': 'transaction_payment_type', 'transaction_payment_confirmation_number': 'transaction_payment_confirmation_number', 'transaction_amount_decimal': 'transaction_amount_decimal' }

        // TODO: Sipra Output
        let columnMap = (this.reportOptions.type === 'summary') ? summaryColumns : detailedColumns

        return new Promise((resolve, reject) => {
          let ledgerData = []

          sortedAccounts.map(accountCode => {
            if (this.reportOptions.type === 'summary') {
              accountCode.transaction = undefined
              ledgerData.push(accountCode)
            } else {
              accountCode.transaction.map(row => ledgerData.push(row))
            }
          })

          this.disableReportRun = false
          let finalCsv = this.createCsv(ledgerData, columnMap)
          if (finalCsv) resolve(finalCsv)
          else reject('Could not build CSV.')
        })
      },

      async payrollInvoiceReport (payrollData) {
        // Make sure we have enough to run report or else the queries could overload the server
        if (!this.selectedCodes.doc_number && !this.selectedCodes.transaction_id) {
          this.$notify({ title: 'Please enter a Payroll ID/#', message: `You must enter in a payroll number OR payroll id (not both).`, type: 'error' })
          return false
        }

        if (!payrollData) {
          let results
          const response = await this.getReportData('payrollinterface')
          results = response.data[0]

          if (!results) {
            // console.log('No results')
            return false
          }

          payrollData = new PayrollInvoiceData(results)
        }

        // await this.resources.EmployeeResource.all({ query: { id__in: payrollData.employeeIds.join(',') } })
        const clientResource = await this.resources.ClientResource.detail(payrollData.clientId)
        const projectResource = await this.resources.ProjectResource.detail(payrollData.projectId)

        if (!clientResource || !clientResource.attributes || !projectResource || !projectResource.attributes) {
          this.$notify({ title: 'Error with transaction', message: 'No client or project info', type: 'error' })
          return false
        }

        const client = clientResource.attributes
        const clientAddressId = client.address_billing || client.address_main || client.address_mailing || client.address_contact || client.address_production_office
        const clientAddress = clientAddressId ? await AddressResource.detail(clientAddressId) : new AddressResource()
        await clientAddress.resolveRelated({ managers: [ 'state', 'city' ] })

        const project = projectResource.attributes
        const projectAddressId = project.address_billing || project.address_main || project.address_mailing || project.address_contact || project.address_production_office
        const projectAddress = projectAddressId ? await AddressResource.detail(projectAddressId) : new AddressResource()
        await projectAddress.resolveRelated({ managers: [ 'state', 'city' ] })

        this.jasperSettings.reportName = 'payroll_invoice'
        // let reportData = payrollData.generateInvoiceData()
        // this.prettyJson = JSON.stringify(reportData, null, 2)

        let json = {
          report: {
            report_title: 'Payroll Batch Invoice',
            report_subtitle: '',
            report_name: 'payroll_batch_invoice',
            printed_by: this.username,
            date_run: this.today().replace(/\//g, '-'),
            time_run: new Date().toTimeString(),
            company_name: 'Revolution Payroll',
            company_address1: '1210 W Burbank Blvd',
            company_address2: '',
            company_city: 'Burbank',
            company_state: 'CA',
            company_postal: '91506',
            company_country: 'United States',
            company_phone: '818-562-7866',
            // clients: clientResource.name_reports,
            client_code: client.code,
            client_name: client.name_reports,
            client_address1: clientAddress.get('line1'),
            client_address2: clientAddress.get('line2'),
            client_city: clientAddress.get('city.name'),
            client_state: clientAddress.get('state.code'),
            client_postal: clientAddress.get('postal'),
            // client_country: clientAddress.get('country.code'),
            client_phone: clientAddress.get('contact_phone'),
            // projects: Superprime - 22004 Ally Bank NASCAR,
            project_number: project.number,
            project_name: project.name,
            project_address1: projectAddress.get('line1'),
            project_address2: projectAddress.get('line2'),
            project_city: projectAddress.get('city.name'),
            project_state: projectAddress.get('state.code'),
            project_postal: projectAddress.get('postal'),
            // project_country: projectAddress.get('country.code'),
            project_phone: projectAddress.get('contact_phone'),
            payrolls: payrollData.payrollId,
            doc_number: payrollData.payrollNumber,
            invoice_number: payrollData.payrollNumber,
            invoice_date: payrollData.invoiceDate,
            check_date: payrollData.invoiceDate,
            ach_draft_date: payrollData.invoiceDate,
            period_ending: payrollData.weekEnding,
            // invoice_subtotal: payrollData.payrollId,
            payment_method: project.credit_type,
            delivery_method: project.delivery_method,
            items_processed: payrollData.assignmentIds.length,
            invoice_subtotal: payrollData.totalInvoiceAmount,
            invoice_total: payrollData.totalInvoiceAmount,
            is_factored: client.factored || project.factored,
            data: payrollData.generatePayrollInvoiceData()
            // invoice_total_minus_available_credits: 145698.54,
          }
        }
        return json
      },

      async customTimeEntryReport (payrollData) {
        // Make sure we have enough to run report or else the queries could overload the server
        if (!this.selectedCodes.doc_number && !this.selectedCodes.transaction_id) {
          this.$notify({ title: 'Please enter a Payroll ID/#', message: `You must enter in a payroll number OR payroll id (not both).`, type: 'error' })
          return false
        }

        if (!payrollData) {
          let results
          const response = await this.getReportData('payrollinterface')
          results = response.data[0]

          if (!results) {
            // console.log('No results')
            return false
          }

          payrollData = new PayrollInvoiceData(results)
        }

        const clientResource = await this.resources.ClientResource.detail(payrollData.clientId)
        const projectResource = await this.resources.ProjectResource.detail(payrollData.projectId)

        if (!clientResource || !clientResource.attributes || !projectResource || !projectResource.attributes) {
          this.$notify({ title: 'Error with transaction', message: 'No client or project info', type: 'error' })
          return false
        }

        const client = clientResource.attributes
        const clientAddressId = client.address_billing || client.address_main || client.address_mailing || client.address_contact || client.address_production_office
        const clientAddress = clientAddressId ? await AddressResource.detail(clientAddressId) : new AddressResource()
        await clientAddress.resolveRelated({ managers: [ 'state', 'city' ] })

        const project = projectResource.attributes
        const projectAddressId = project.address_billing || project.address_main || project.address_mailing || project.address_contact || project.address_production_office
        const projectAddress = projectAddressId ? await AddressResource.detail(projectAddressId) : new AddressResource()
        await projectAddress.resolveRelated({ managers: [ 'state', 'city' ] })

        this.jasperSettings.reportName = 'custom_time_entry_audit'
        // this.jasperSettings.reportName = 'custom_time_entry_summary'
        // let reportData = payrollData.generateInvoiceData()
        // this.prettyJson = JSON.stringify(reportData, null, 2)

        let json = {
          report: {
            report_title: 'Custom Time Entry Report',
            report_subtitle: 'Custom Time Entry',
            report_name: 'Custom Time Entry Report',
            printed_by: this.username,
            date_run: this.today().replace(/\//g, '-'),
            time_run: new Date().toTimeString(),
            company_name: 'Revolution Payroll',
            company_address1: '1210 W Burbank Blvd',
            company_address2: '',
            company_city: 'Burbank',
            company_state: 'CA',
            company_postal: '91506',
            company_country: 'United States',
            company_phone: '818-562-7866',
            // clients: clientResource.name_reports,
            client_code: client.name_reports,
            client_name: client.name_reports,
            client_address1: clientAddress.get('line1'),
            client_address2: clientAddress.get('line2'),
            client_city: clientAddress.get('city.name'),
            client_state: clientAddress.get('state.code'),
            client_postal: clientAddress.get('postal'),
            // client_country: clientAddress.get('country.code'),
            client_phone: clientAddress.get('contact_phone'),
            // projects: Superprime - 22004 Ally Bank NASCAR,
            project_number: project.number,
            project_name: project.name,
            project_address1: projectAddress.get('line1'),
            project_address2: projectAddress.get('line2'),
            project_city: projectAddress.get('city.name'),
            project_state: projectAddress.get('state.code'),
            project_postal: projectAddress.get('postal'),
            // project_country: projectAddress.get('country.code'),
            project_phone: projectAddress.get('contact_phone'),
            payrolls: payrollData.payrollId || 'ALL',
            payroll_invoice_numbers: payrollData.payrollNumber || 'ALL',
            clients: client.name_reports || 'ALL',
            projects: project.name || 'ALL',
            check_date: payrollData.invoiceDate,
            gross_wages: 0,

            pay_period_start_date: payrollData.payPeriodStartDate,
            pay_period_end_date: payrollData.payPeriodEndDate,
            check_date_start: payrollData.invoiceDate,
            check_date_end: payrollData.invoiceDate,
            data: await payrollData.generateCustomTimeEntryData()
          }
        }

        return json
      },

      async detailPayEditReport (payrollData) {
        // Make sure we have enough to run report or else the queries could overload the server
        if (!this.selectedCodes.doc_number && !this.selectedCodes.transaction_id) {
          this.$notify({ title: 'Please enter a Payroll ID/#', message: `You must enter in a payroll number OR payroll id (not both).`, type: 'error' })
          return false
        }

        if (!payrollData) {
          let results
          const response = await this.getReportData('payrollinterface')
          results = response.data[0]

          if (!results) {
            // console.log('No results')
            return false
          }

          payrollData = new PayrollInvoiceData(results)
        }

        const clientResource = await this.resources.ClientResource.detail(payrollData.clientId)
        const projectResource = await this.resources.ProjectResource.detail(payrollData.projectId)

        if (!clientResource || !clientResource.attributes || !projectResource || !projectResource.attributes) {
          this.$notify({ title: 'Error with transaction', message: 'No client or project info', type: 'error' })
          return false
        }

        const client = clientResource.attributes
        const clientAddressId = client.address_billing || client.address_main || client.address_mailing || client.address_contact || client.address_production_office
        const clientAddress = clientAddressId ? await AddressResource.detail(clientAddressId) : new AddressResource()
        await clientAddress.resolveRelated({ managers: [ 'state', 'city' ] })

        const project = projectResource.attributes
        const projectAddressId = project.address_billing || project.address_main || project.address_mailing || project.address_contact || project.address_production_office
        const projectAddress = projectAddressId ? await AddressResource.detail(projectAddressId) : new AddressResource()
        await projectAddress.resolveRelated({ managers: [ 'state', 'city' ] })

        this.jasperSettings.reportName = 'pr_detail_edit_report'
        let reportData = payrollData.generateDetailPayEdit()

        let json = {
          report: {
            report_title: 'Detail Pay Edit',
            report_subtitle: '',
            report_name: 'detail_pay_edit',
            printed_by: this.username,
            date_run: this.today().replace(/\//g, '-'),
            time_run: new Date().toTimeString(),

            company_name: 'Revolution Payroll',
            company_address1: '1210 W Burbank Blvd',
            company_address2: '',
            company_city: 'Burbank',
            company_state: 'CA',
            company_postal: '91506',
            company_country: 'United States',
            company_phone: '818-562-7866',

            clients: client.name_reports,
            projects: project.name,
            payrolls: payrollData.payrollId || 'ALL',
            payroll_invoice_numbers: payrollData.payrollNumber || 'ALL',

            pay_period_start_date: payrollData.payPeriodStartDate,
            pay_period_end_date: payrollData.payPeriodEndDate,
            check_date_start: payrollData.invoiceDate,
            check_date_end: payrollData.invoiceDate,

            currency: (this.reportOptions.report_currency_id) ? (this.allCodes.currencies.find(({id}) => id === this.reportOptions.report_currency_id).code) : this.currencies[0].code,
            gross_grand_total: this.sumRecursive(reportData, 'gross_total'),
            grand_total: 0,
            transaction_type: 'PR',
            employee_count: reportData.length || 0,
            data: reportData
          }
        }

        return json
      },

      async payrollCheckRegisterReport (payrollData, employeeYtdData) {
        // Make sure we have enough to run report or else the queries could overload the server
        if (!this.selectedCodes.doc_number && !this.selectedCodes.transaction_id) {
          this.$notify({ title: 'Please enter a Payroll ID/#', message: `You must enter in a payroll number OR payroll id (not both).`, type: 'error' })
          return false
        }

        if (!payrollData) {
          let results
          const response = await this.getReportData('payrollinterface')
          results = response.data[0]

          if (!results || !results) {
            // console.log('No results')
            return false
          }

          payrollData = new PayrollInvoiceData(results)
        }

        if (!employeeYtdData) {
          let results
          let selectedCodes = Object.assign({}, this.selectedCodes)
          selectedCodes.check_date_start = '2022-01-01'
          selectedCodes.check_date_end = payrollData.invoiceDate || '2022-12-31'
          selectedCodes.transaction_id = undefined
          selectedCodes.doc_number = undefined
          selectedCodes.pay_period_start_date = undefined
          selectedCodes.pay_period_end_date = undefined
          // selectedCodes.employee_id = undefined
          selectedCodes.employee_id = payrollData.employeeIds

          const response = await this.getReportData('employeeytd', { selectedCodes })
          results = response.data

          if (!results || !results) {
            // console.log('No results')
            return false
          }

          employeeYtdData = results
        }

        payrollData.addEmployeeYTDData(employeeYtdData)

        let reportData = await payrollData.generateWageCheckRegisterData()
        this.prettyJson = JSON.stringify(reportData, null, 2)

        const clientResource = await this.resources.ClientResource.detail(payrollData.clientId)
        const projectResource = await this.resources.ProjectResource.detail(payrollData.projectId)

        if (!clientResource || !clientResource.attributes || !projectResource || !projectResource.attributes) {
          this.$notify({ title: 'Error with transaction', message: 'No client or project info', type: 'error' })
          return false
        }

        const client = clientResource.attributes
        const clientAddressId = client.address_billing || client.address_main || client.address_mailing || client.address_contact || client.address_production_office
        const clientAddress = clientAddressId ? await AddressResource.detail(clientAddressId) : new AddressResource()
        await clientAddress.resolveRelated({ managers: [ 'state', 'city' ] })

        const project = projectResource.attributes
        const projectAddressId = project.address_billing || project.address_main || project.address_mailing || project.address_contact || project.address_production_office
        const projectAddress = projectAddressId ? await AddressResource.detail(projectAddressId) : new AddressResource()
        await projectAddress.resolveRelated({ managers: [ 'state', 'city' ] })

        this.jasperSettings.reportName = 'pr_check_register_report'
        // this.jasperSettings.reportName = 'custom_time_entry_summary'
        // let reportData = payrollData.generateInvoiceData()
        // this.prettyJson = JSON.stringify(reportData, null, 2)

        let json = {
          report: {
            report_title: 'Payroll Wage Register',
            report_subtitle: 'Payroll Wage Register',
            report_name: 'Payroll Wage Register',
            printed_by: this.username,
            date_run: this.today().replace(/\//g, '-'),
            time_run: new Date().toTimeString(),
            company_name: 'Revolution Payroll',
            company_address1: '1210 W Burbank Blvd',
            company_address2: '',
            company_city: 'Burbank',
            company_state: 'CA',
            company_postal: '91506',
            company_country: 'United States',
            company_phone: '818-562-7866',

            client_code: client.code,
            client_name: client.name_reports,
            clients: client.name_reports,
            client_address1: clientAddress.get('line1'),
            client_address2: clientAddress.get('line2'),
            client_city: clientAddress.get('city.name'),
            client_state: clientAddress.get('state.code'),
            client_postal: clientAddress.get('postal'),
            client_phone: clientAddress.get('contact_phone'),
            project_number: project.number,
            project_name: project.name,
            projects: project.name,
            project_address1: projectAddress.get('line1'),
            project_address2: projectAddress.get('line2'),
            project_city: projectAddress.get('city.name'),
            project_state: projectAddress.get('state.code'),
            project_postal: projectAddress.get('postal'),
            // project_country: projectAddress.get('country.code'),
            project_phone: projectAddress.get('contact_phone'),
            payment_method: project.credit_type,
            delivery_method: project.delivery_method,
            ach_draft_date: payrollData.invoiceDate,
            period_ending: payrollData.weekEnding,
            items_processed: payrollData.assignmentIds.length,
            invoice_subtotal: payrollData.totalInvoiceAmount,
            payrolls: payrollData.payrollId || 'ALL',
            invoice_number: payrollData.payrollNumber,
            doc_number: payrollData.payrollNumber,
            payroll_invoice_numbers: payrollData.payrollNumber || 'ALL',
            check_date: payrollData.invoiceDate,
            gross_wages: 0,

            net_wages_grand_total: payrollData.totalEeWages,
            postage_delivery_fees_grand_total: payrollData.totalEeWages,
            deductions_grand_total: payrollData.totalEeWages,
            gross_wages_grand_total: payrollData.totalEeWages,
            direct_deposit_grand_total: payrollData.totalEeWages,
            live_check_grand_total: payrollData.totalEeWages,
            invoice_total_minus_available_credits: payrollData.totalEeWages,
            pay_code_grand_total: payrollData.totalEeWages,
            withholding_grand_total: payrollData.totalEeWages,
            er_billed_benefits_grand_total: payrollData.totalEeWages,
            pay_code_totals: reportData.payCodeTotals,
            withholding_totals: reportData.taxTotals,
            deduction_totals: reportData.deductionTotals,
            /*

            "check_count": 1,
            "client_credits": 0.0,
            "pay_code_totals": [
                {
                    "state": "CA",
                    "total": 2400.0,
                    "pay_code_detail": [
                        {
                            "amount": "1745.50",
                            "hours_units": "80.0000",
                            "pay_code": "100 - Straight-Time"
                        },
                        {
                            "amount": "654.50",
                            "hours_units": "20.0000",
                            "pay_code": "150 - Time-and-One-Half"
                        }
                    ]
                }
            ],
            "deduction_totals": [
                {
                    "deduction": "CL HLTHPRE",
                    "ytd_amount": "-195.53",
                    "amount": "-195.53"
                }
            ],
            "withholding_totals": [
                {
                    "deduction": "FICA",
                    "ytd_amount": "136.68",
                    "amount": "136.68"
                },
                {
                    "deduction": "Medicare",
                    "ytd_amount": "31.96",
                    "amount": "31.96"
                },
                {
                    "deduction": "Federal Income Tax",
                    "ytd_amount": "206.83",
                    "amount": "206.83"
                }
            ],

            */

            pay_period_start_date: payrollData.payPeriodStartDate,
            pay_period_end_date: payrollData.payPeriodEndDate,
            check_date_start: payrollData.invoiceDate,
            check_date_end: payrollData.invoiceDate,
            data: reportData.data
          }
        }

        // return false
        return json
      },

      async fringeRecapReport (payrollData) {
        // Make sure we have enough to run report or else the queries could overload the server
        if (!this.selectedCodes.doc_number && !this.selectedCodes.transaction_id) {
          this.$notify({ title: 'Please enter a Payroll ID/#', message: `You must enter in a payroll number OR payroll id (not both).`, type: 'error' })
          return false
        }

        if (!payrollData) {
          let results
          const response = await this.getReportData('payrollinterface')
          results = response.data[0]

          if (!results) {
            // console.log('No results')
            return false
          }

          payrollData = new PayrollInvoiceData(results)
        }

        // await this.resources.EmployeeResource.all({ query: { id__in: payrollData.employeeIds.join(',') } })
        const clientResource = await this.resources.ClientResource.detail(payrollData.clientId)
        const projectResource = await this.resources.ProjectResource.detail(payrollData.projectId)

        if (!clientResource || !clientResource.attributes || !projectResource || !projectResource.attributes) {
          this.$notify({ title: 'Error with transaction', message: 'No client or project info', type: 'error' })
          return false
        }

        const client = clientResource.attributes
        const project = projectResource.attributes

        this.jasperSettings.reportName = 'fringe_recap_detail'
        let reportData = payrollData.generateFringeRecapData()
        // this.prettyJson = JSON.stringify(reportData, null, 2)

        let json = {
          report: {
            report_title: 'Fringe Recap',
            report_subtitle: '',
            report_name: 'fringe_recap',
            printed_by: this.username,
            date_run: this.today().replace(/\//g, '-'),
            time_run: new Date().toTimeString(),
            company_name: 'Revolution Payroll',
            company_address1: '1210 W Burbank Blvd',
            company_address2: '',
            company_city: 'Burbank',
            company_state: 'CA',
            company_postal: '91506',
            company_country: 'United States',
            company_phone: '818-562-7866',
            clients: client.name_reports,
            projects: project.name,
            payrolls: payrollData.payrollId || 'ALL',
            payroll_invoice_numbers: payrollData.payrollNumber || 'ALL',

            taxable_wages: payrollData.taxablePay,
            non_taxable_wages: payrollData.nonTaxablePay,
            total_cost: payrollData.totalInvoiceAmount,
            total_fringe: payrollData.totalErCost,
            credit_to_client_deductions: payrollData.erReturnedDeductions,
            admin_fees: payrollData.handlingFees,
            wc_fees: payrollData.wcFees,
            futa_fees: payrollData.erFuta,
            suta_fees: payrollData.erSuta + payrollData.erSdi,
            fica_fees: payrollData.erFica,
            union_benefit_fees: payrollData.totalUnionBenefits,
            other_payroll_tax_fees: payrollData.postageDelivery + payrollData.erBusinessTax + payrollData.erSalesTax,
            local_taxes: payrollData.erLocalTax + payrollData.erLocalTaxFees,
            // vacation_holiday: payrollData.,
            vacation_holiday: 0,
            pay_period_start_date: payrollData.payPeriodStartDate,
            pay_period_end_date: payrollData.payPeriodEndDate,
            check_date_start: payrollData.invoiceDate,
            check_date_end: payrollData.invoiceDate,
            data: reportData
          }
        }
        return json
      },

      async aggregateFringeRecapReport (payrollData) {
        // Make sure we have enough to run report or else the queries could overload the server
        if (!this.selectedCodes.client_id && !this.selectedCodes.project_id) {
          this.$notify({ title: 'Please enter a Payroll ID/#', message: `You must enter in a payroll number OR payroll id (not both).`, type: 'error' })
          return false
        }

        // Unset the payroll id/number
        this.selectedCodes.doc_number = undefined
        this.selectedCodes.transaction_id = undefined

        if (!payrollData) {
          let results
          const response = await this.getReportData('payrollinterface')
          results = response.data[0]

          if (!results) {
            // console.log('No results')
            return false
          }

          payrollData = new PayrollInvoiceData(results)
          // console.log(results, payrollData)
        }

        // await this.resources.EmployeeResource.all({ query: { id__in: payrollData.employeeIds.join(',') } })
        const clientResource = await this.resources.ClientResource.detail(payrollData.clientId)
        const projectResource = await this.resources.ProjectResource.detail(payrollData.projectId)

        if (!clientResource || !clientResource.attributes || !projectResource || !projectResource.attributes) {
          this.$notify({ title: 'Error with transaction', message: 'No client or project info', type: 'error' })
          return false
        }

        const client = clientResource.attributes
        const project = projectResource.attributes

        this.jasperSettings.reportName = 'fringe_recap_detail'
        let reportData = payrollData.generateFringeRecapData()
        // this.prettyJson = JSON.stringify(reportData, null, 2)

        let json = {
          report: {
            report_title: 'Aggregate Fringe Recap',
            report_subtitle: 'Aggregate Fringe Recap',
            report_name: 'fringe_recap',
            printed_by: this.username,
            date_run: this.today().replace(/\//g, '-'),
            time_run: new Date().toTimeString(),
            company_name: 'Revolution Payroll',
            company_address1: '1210 W Burbank Blvd',
            company_address2: '',
            company_city: 'Burbank',
            company_state: 'CA',
            company_postal: '91506',
            company_country: 'United States',
            company_phone: '818-562-7866',
            clients: client.name_reports,
            projects: project.name || 'ALL',
            payrolls: payrollData.payrollId || 'ALL',
            payroll_invoice_numbers: payrollData.payrollNumber || 'ALL',

            taxable_wages: payrollData.taxablePay,
            non_taxable_wages: payrollData.nonTaxablePay,
            total_cost: payrollData.totalInvoiceAmount,
            total_fringe: payrollData.totalErCost,
            credit_to_client_deductions: payrollData.erReturnedDeductions,
            admin_fees: payrollData.handlingFees,
            wc_fees: payrollData.wcFees,
            futa_fees: payrollData.erFuta,
            suta_fees: payrollData.erSuta + payrollData.erSdi,
            fica_fees: payrollData.erFica,
            union_benefit_fees: payrollData.totalUnionBenefits,
            other_payroll_tax_fees: payrollData.postageDelivery + payrollData.erBusinessTax + payrollData.erSalesTax,
            local_taxes: payrollData.erLocalTax + payrollData.erLocalTaxFees,
            // vacation_holiday: payrollData.,
            vacation_holiday: 0,
            pay_period_start_date: payrollData.payPeriodStartDate,
            pay_period_end_date: payrollData.payPeriodEndDate,
            check_date_start: payrollData.invoiceDate,
            check_date_end: payrollData.invoiceDate,
            data: reportData
          }
        }
        return json
      },

      async aggregateFringeRecapByPaycodeReport (payrollData) {
        // Make sure we have enough to run report or else the queries could overload the server
        if (!this.selectedCodes.client_id && !this.selectedCodes.project_id || !this.reportOptions.paycodeId) {
          this.$notify({ title: 'Please enter a Payroll ID/#', message: `You must enter a paycode and a payroll number OR payroll id (not both).`, type: 'error' })
          return false
        }

        // Unset the payroll id/number
        this.selectedCodes.doc_number = undefined
        this.selectedCodes.transaction_id = undefined

        if (!payrollData) {
          let results
          const response = await this.getReportData('payrollinterface')
          results = response.data[0]

          if (!results) {
            // console.log('No results')
            return false
          }

          // Now need to find the paycode lines and those related to it.
          const payLinesIds = results.reduce((acc, line) => {
            // Since sigma-query is grouping lines, need to extract them and convert them to a JS array
            if (parseInt(line.pay_code_id) === parseInt(this.reportOptions.paycodeId)) acc = [ ...acc, ...(JSON.parse(line.line_ids)) ]
            return acc
          }, [])

          const filteredResults = results.filter((line) => parseInt(line.pay_code_id) === parseInt(this.reportOptions.paycodeId) || payLinesIds.includes(line.referencing_line_id))
          payrollData = new PayrollInvoiceData(filteredResults)
        }

        const clientResource = await this.resources.ClientResource.detail(payrollData.clientId)
        const projectResource = await this.resources.ProjectResource.detail(payrollData.projectId)

        if (!clientResource || !clientResource.attributes || !projectResource || !projectResource.attributes) {
          this.$notify({ title: 'Error with transaction', message: 'No client or project info', type: 'error' })
          return false
        }

        const client = clientResource.attributes
        const project = projectResource.attributes

        this.jasperSettings.reportName = 'fringe_recap_detail'
        let reportData = payrollData.generateFringeRecapData()
        // this.prettyJson = JSON.stringify(reportData, null, 2)

        let json = {
          report: {
            report_title: 'Aggregate Paycode Recap',
            report_subtitle: 'Aggregate Paycode Recap',
            report_name: 'fringe_recap',
            printed_by: this.username,
            date_run: this.today().replace(/\//g, '-'),
            time_run: new Date().toTimeString(),
            company_name: 'Revolution Payroll',
            company_address1: '1210 W Burbank Blvd',
            company_address2: '',
            company_city: 'Burbank',
            company_state: 'CA',
            company_postal: '91506',
            company_country: 'United States',
            company_phone: '818-562-7866',
            clients: client.name_reports,
            projects: project.name || 'ALL',
            payrolls: payrollData.payrollId || 'ALL',
            payroll_invoice_numbers: payrollData.payrollNumber || 'ALL',

            taxable_wages: payrollData.taxablePay,
            non_taxable_wages: payrollData.nonTaxablePay,
            total_cost: payrollData.totalInvoiceAmount,
            total_fringe: payrollData.totalErCost,
            credit_to_client_deductions: payrollData.erReturnedDeductions,
            admin_fees: payrollData.handlingFees,
            wc_fees: payrollData.wcFees,
            futa_fees: payrollData.erFuta,
            suta_fees: payrollData.erSuta + payrollData.erSdi,
            fica_fees: payrollData.erFica,
            union_benefit_fees: payrollData.totalUnionBenefits,
            other_payroll_tax_fees: payrollData.postageDelivery + payrollData.erBusinessTax + payrollData.erSalesTax,
            local_taxes: payrollData.erLocalTax + payrollData.erLocalTaxFees,
            // vacation_holiday: payrollData.,
            vacation_holiday: 0,
            pay_period_start_date: payrollData.payPeriodStartDate,
            pay_period_end_date: payrollData.payPeriodEndDate,
            check_date_start: payrollData.invoiceDate,
            check_date_end: payrollData.invoiceDate,
            data: reportData
          }
        }
        return json
      },

      async paystubReport () {
        // Make sure we have enough to run report or else the queries could overload the server
        if (this.selectedCodes.doc_number && !this.selectedCodes.transaction_id) {
          this.$notify({ title: 'Please enter a Payroll ID', message: `You must enter in a payroll ID (not payroll invoice number).`, type: 'error' })
          return false
        }

        // console.log(this.invoice_based_pay_period_date_start)
        // console.log(this.invoice_based_pay_period_date_end)

        let query = {
          payroll: this.selectedCodes.transaction_id,
          jwt: this.token,
          check_date__gte: this.invoice_based_pay_period_date_start,
          check_date__lte: this.invoice_based_pay_period_date_end
        }

        if (this.selectedCodes.employee_id) {
          query.employee = this.selectedCodes.employee_id
        }

        this.jasperSettings.reportName = 'pay_check_and_stub_reprint'
        const response = await this.resources.ReportCheckStubHistoryResource.list({ query })
        const reportData = response.resources && response.resources.length ? response.resources[0].attributes.report : null

        // console.log(reportData)
        return reportData ? { report: reportData } : false
      },

      async generateReport () {
        const fileReportType = this.reportOptions.type + 'Report'
        if (this.disableReportRun || typeof this[fileReportType] !== 'function') {
          return false
        }

        // Reset ag-grids
        this.wageRowData = undefined

        try {
          // this.loading = true
          this.disableReportRun = true
          // this.createNotification('Success', `${this.payrollData.projectName} Export is Ready.`, 'success', false, this.reportOptions.format, `${this.payrollData.payrollNumber}-${this.reportOptions.type}`)
          this.reportJson = await this[fileReportType]()

          if (this.reportJson === false) {
            // something went wrong
            this.loading = false
            this.disableReportRun = false
            // this.$notify({ title: 'There was an error running this report', message: `Please call support.`, type: 'error' })
            // return false
          } else {
            this.prettyJson = JSON.stringify(this.reportJson, null, 2)

            const report = this.jasperSettings.reportServer + this.jasperSettings.reportName + '.pdf?net.sf.jasperreports.json.source=' + await this.getJsonUrl(this.reportJson)
            // const preview = this.jasperSettings.reportServer + this.jasperSettings.reportName + '.html?net.sf.jasperreports.json.source=' + await this.getJsonUrl(this.reportJson)
            this.createNotification('Success', 'Report is Ready. ', 'success', await this.getReportUrl(report))
            // console.log(preview)
          }
        } catch (error) {
          console.log('Error')
          console.log(error)
        } finally {
          this.loading = false
          this.disableReportRun = false
          this.reportOptions.type = null
        }

        this.loading = false
        this.disableReportRun = false
        return this.reportJson
      },

      async payrollWageListReport (payrollData) {
        // Make sure we have enough to run report or else the queries could overload the server
        if (!this.selectedCodes.doc_number && !this.selectedCodes.transaction_id) {
          this.$notify({ title: 'Please enter a Payroll ID/#', message: `You must enter in a payroll number OR payroll id (not both).`, type: 'error' })
          return false
        }

        if (!payrollData) {
          let results
          const response = await this.getReportData('payrollinterface')
          results = response.data[0]

          if (!results || !results) {
            // console.log('No results')
            return false
          }

          payrollData = results // new PayrollInvoiceData(results)
          this.wageRowData = results
        }

        this.disableReportRun = this.loading = false
        return false
      }
    },

    created () {
      // Load data to be used for validation
      this.disableReportRun = true
      this.getCompanyData()
        .then(response => {
          this.allCodes = Object.assign({}, response.data)
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.disableReportRun = false
        })
    },

    beforeUnmount () {
      this.resetComponent()
    }
  }

</script>
<style scoped>
  .small { font-size: 8px; }
  .right { float: right; text-align: right; padding: 0px 5px; }
  .left { float: left; text-align: left; padding: 0px 5px; }
  .selectRow { padding: 0px 20px; }
  .section { padding: 40px 20px 0px;  }
  .headerRow { padding: 15px 20px 0px; }
  .m-top-20 { margin-top: 20px; }
  .m-right-20 { margin-right: 20px; }
</style>
<style>
  .el-select { display: block; }
  .el-transfer-panel { width:36%; max-width: 350px }
  .el-transfer-panel__body { min-height: 400px }
  .el-transfer-panel__list { min-height: 360px }
  /* border: 1px solid #d1dbe5; box-shadow: 0 2px 4px rgba(0, 0, 0, .12),0 0 6px rgba(0, 0, 0, .04); display: inline-block; width: 30%; position: relative; height: 500px; */
</style>
